class SliderComment extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.swiperInit();
  }

  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }

  swiperInit() {
    this.swiper = new Swiper(".swiper-comment", {
      slidesPerView: "auto",
      spaceBetween: 6,
      freeMode: {
        enabled: true,
        sticky: true,
        momentumRatio: 0.5,
      },
      mousewheel: {
        forceToAxis: true,
        thresholdDelta: 15,
        thresholdTime: 100,
        releaseOnEdges: true,
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: this.querySelector(".swiper-button-next"),
        prevEl: this.querySelector(".swiper-button-prev"),
      },
      breakpoints: {
        990: { spaceBetween: 18 },
      },
    });
  }
}

customElements.define("slider-comment", SliderComment);
